import React from 'react';
import { ITekstOgBilledeListe } from './tekstOgBilledeListe.definition';
import TekstOgBillede from '@Components/tekstOgBillede';

const TekstOgBilledeListe = ({ list }: ITekstOgBilledeListe) => {
	if (!list || list.length < 1) {
		return null;
	}

	return (
		<section className="text-og-billede--liste">
			{ list.map((item, index) => (
				<TekstOgBillede
					reverse={ index % 2 === 0 }
					billedeBaggrundsFarve={ index % 2 === 0 ? 'primary' : 'secondary' }
					key={ index }
					/* vis ikke scroll ikon paa det sidste element */
					visScrollIkon={ list.length - 1 !== index }
					listLength={ list.length }
					currentIndex={ index }
					{ ...item }
				/>
			)) }
		</section>
	);
};

export default TekstOgBilledeListe;
